import { Car, UserCustomAttribute } from '@hefe/models';
import { CarsSlice, ClubSlice, ModalsSlice } from '@hefe/store';
import { t } from '@hefe/i18n';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface AddEditCustomUserAttributeFormProps {
  attribute?: UserCustomAttribute;
}

export default function AddEditCustomUserAttributeForm(
  props: AddEditCustomUserAttributeFormProps
) {
  const { attribute } = props;

  const dispatch = useAppDispatch();
  const modalState = useSelector(ModalsSlice.modalsState);
  const userAttributeTypes = useSelector(
    ClubSlice.customUserAttributeTypesSelectSelector
  );

  const onSubmit = (values: any, resetForm: any) => {
    const closeModal = ModalsSlice.modalsActions.closeModal;
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;

    const action = attribute
      ? ClubSlice.updateClubCustomUserAttribute
      : ClubSlice.createClubCustomUserAttribute;

    dispatch(setModalLoading(true));
    dispatch(
      action({
        ...values,
        ...(attribute ? { id: attribute.id } : {}),
      })
    )
      .unwrap()
      .then(() => {
        dispatch(closeModal());
        resetForm();
      })
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  return (
    <CustomForm
      key={`add-edit-custom-user-attribute-form-${
        attribute ? attribute.id : 'new'
      }`}
      formId={`add-edit-custom-user-attribute-form-${
        attribute ? attribute.id : 'new'
      }`}
      fields={[
        {
          name: 'name',
          label: t('name'),
          type: 'text',
          initalValue: attribute?.name,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'type',
          label: t('type'),
          type: 'select',
          initalValue: attribute?.type,
          selectOptions: userAttributeTypes,
          rules: [
            {
              required: true,
              message: t('form_errors.value'),
            },
          ],
        },
      ]}
      loading={modalState.modal.loading}
      onSubmit={onSubmit}
    />
  );
}
